<template>
    <div>
        <div class="live-event group-game">
            <!--div class="ggame-heading">
                <div class="ggame-heading-left">
                    <span class="ggame-heading-icon sport-icon sporticon-1"></span>
                    <h2 class="ggame-heading-text">{{sportTree.tournaments[matchesIn[matchId].tournamentId].tournamentName}}: {{matchesIn[matchId].teamNameOne}} - {{matchesIn[matchId].teamNameTwo}}</h2>
                </div>
                <div class="ggame-heading-right">
                    <div class="live-event-fav">
                        <img src="../../../assets/img/favourites-light-unselected.svg" alt="down arrow">
                    </div>
                    <div class="arrow-container">
                        <img src="../../../assets/img/arrow-up-light.svg" alt="down arrow">
                    </div>
                </div>
            </div-->
            <div class="live-event-container">
                <div class="live-event-content">
                    <div class="live-event-top">
                        <div class="stats-row">
                            <div class="stats-row">
                                <div class="stats-row-left">
                                    <p class="live-stats-time">{{currentScore}}</p>
                                </div>
                                <div class="stats-row-right">
                                    <div class="live-stats-item">
                                        <span class="sport-icon" :class="'sporticon-'+matchesIn[matchId].sportId"></span>
                                    </div>
                                    <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1RCrd != undefined || matchesIn[matchId].metaData.t2RCrd != undefined">
                                        <img src="../../../assets/img/red-card.svg" alt="red card">
                                    </div>
                                    <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1YCrd != undefined || matchesIn[matchId].metaData.t2YCrd != undefined">
                                        <img src="../../../assets/img/yellow-card.svg" alt="yellow card">
                                    </div>
                                    <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1Crn != undefined || matchesIn[matchId].metaData.t2Crn != undefined">
                                        <img src="../../../assets/img/corner.svg" alt="">
                                    </div>
                                    <!-- div class="live-stats-item">
                                        <img src="../../../assets/img/11-m.svg" alt="">
                                    </div -->
                                    <div class="live-stats-item" v-for="(period, p) in matchesIn[matchId].metaData.periods" :key="p">
                                        {{period.num}}
                                    </div>
                                </div>
                            </div>
                            <div class="stats-line"></div>
                        </div>
                        <div class="stats-line"></div>
                    </div>
                    <div class="live-event-bottom">
                        <div class="stats-row bottom">
                            <div class="stats-row-left">
                                <p class="live-stats-team">{{matchesIn[matchId].teamNameOne}}</p>
                            </div>
                            <div class="stats-row-right">
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1Scr != undefined">{{matchesIn[matchId].metaData.t1Scr}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1RCrd != undefined">{{matchesIn[matchId].metaData.t1RCrd}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1YCrd != undefined">{{matchesIn[matchId].metaData.t1YCrd}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t1Crn != undefined">{{matchesIn[matchId].metaData.t1Crn}}</div>
                                <!-- div class="live-stats-item">0</div -->
                                <div class="live-stats-item" v-for="(period, p) in matchesIn[matchId].metaData.periods" :key="p">{{period.t1Scr}}</div>
                            </div>
                        </div>
                        <div class="stats-row bottom">
                            <div class="stats-row-left">
                                <p class="live-stats-team">{{matchesIn[matchId].teamNameTwo}}</p>
                            </div>
                            <div class="stats-row-right">
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t2Scr != undefined">{{matchesIn[matchId].metaData.t2Scr}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t2RCrd != undefined">{{matchesIn[matchId].metaData.t2RCrd}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t2YCrd != undefined">{{matchesIn[matchId].metaData.t2YCrd}}</div>
                                <div class="live-stats-item" v-if="matchesIn[matchId].metaData.t2Crn != undefined">{{matchesIn[matchId].metaData.t2Crn}}</div>
                                <!-- div class="live-stats-item">0</div -->
                                <div class="live-stats-item" v-for="(period, p) in matchesIn[matchId].metaData.periods" :key="p">{{period.t2Scr}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="single-game-sport" :class="(matchesIn[matchId].status == 'block') ? 'is-blocked' : ''">
            <div class="sgame-odds-box" v-for="group in groups" :key="group.marketId">
                <p class="sgame-odds-header">{{group.printName}}</p>
                <div class="sgame-odds-container">
                    <div class="sgame-odds-content">
                        <Outcome v-for="outcome in group.outcomes"
                        v-bind:outcome="outcome"
                        v-bind:match="matchesIn[match.matchId]"
                        v-bind:key="outcome.outcomeId"
                        v-bind:details="true"></Outcome>
                    </div>
                    <div class="sgame-stats">
                        <img src="../../../assets/img/statistics.svg" alt="stats image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import
{
    mapGetters,
}
from 'vuex';
import { Common } from '@om-retail/vue-common';
import Outcome from '../../components/Outcome.vue';

export default
{
    name: 'LiveEventView',
    components:
    {
        Outcome,
    },
    methods:
    {
        generateGroups()
        {
            const me = this;

            if (me.match === undefined)
            {
                return;
            }

            const groups = {};
            for (const outcome of me.match.outcomes)
            {
                const marketId = outcome.markets[0];
                if (groups[marketId] === undefined)
                {
                    groups[marketId] = {
                        marketId,
                        orderNum: me.sportTree.markets[marketId].orderNum,
                        printName: me.sportTree.markets[marketId].printName,
                        outcomes: {},
                    };
                }

                outcome.printName = Common
                    .formatOddName(me.sportTree.outcomes[outcome.outcomeId].printName, me.match, outcome);

                groups[marketId].outcomes[outcome.outcomeId] = outcome;
            }

            const groupsFin = [];
            for (const marketId in groups)
            {
                if (groups[marketId] !== undefined)
                {
                    const group = groups[marketId];

                    const outcomes = [];
                    for (const outcomeId in group.outcomes)
                    {
                        if (group.outcomes[outcomeId] !== undefined)
                        {
                            outcomes.push(group.outcomes[outcomeId]);
                        }
                    }

                    group.outcomes = outcomes;

                    groupsFin.push(group);
                }
            }

            me.groups = groupsFin;
        },
    },
    watch:
    {
        matchesIn:
        {
            handler()
            {
                const me = this;
                me.generateGroups();
            },
            deep: true,
            immediate: true,
        },
        selectedMatch:
        {
            handler(oldValue, newValue)
            {
                const me = this;

                if (oldValue == null
                || newValue == null
                || oldValue.type !== newValue.type
                || (oldValue.type === newValue.type
                && oldValue.id !== newValue.id))
                {
                    me.groups = [];
                }
            },
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
            'isMobile',
            'sportState',
            'sportTree',
            'selectedMatch',
            'matchesIn',
        ]),
        matchId()
        {
            const me = this;
            return me.selectedMatch.id;
        },
        currentScore()
        {
            const me = this;
            let score = '';

            if (me.matchesIn[me.matchId].metaData.periods)
            {
                let period = null;
                let overtime = false;

                for (const periodSec of me.matchesIn[me.matchId].metaData.periods)
                {
                    if (periodSec.type === 'RegularPeriod')
                    {
                        period = periodSec.num;
                    }
                    else if (periodSec.type === 'Overtime')
                    {
                        overtime = true;
                    }
                }

                if (period != null)
                {
                    score += `${period} ${me.$t('PERIOD')}`;
                }

                if (overtime)
                {
                    score += ` (${me.$t('OVERTIME')})`;
                }

                if (period != null)
                {
                    score += ' - ';
                }
            }

            if (me.matchesIn[me.matchId].metaData !== undefined)
            {
                if (me.matchesIn[me.matchId].metaData.t1GemScr != null)
                {
                    score += me.matchesIn[me.matchId].metaData.t1GemScr;
                    score += ':';
                }
                else if (me.matchesIn[me.matchId].metaData.t1Scr != null)
                {
                    score += me.matchesIn[me.matchId].metaData.t1Scr;
                    score += ':';
                }

                if (me.matchesIn[me.matchId].metaData.t1GemScr != null)
                {
                    score += me.matchesIn[me.matchId].metaData.t2GemScr;
                }
                else if (me.matchesIn[me.matchId].metaData.t1Scr != null)
                {
                    score += me.matchesIn[me.matchId].metaData.t2Scr;
                }
            }

            return score;
        },
    },
};
</script>
